import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getOrgCode } from '../../../helper/utils.helper';
import toast from 'react-hot-toast';
import AssessmentItem from './AssessmentItem';
import SelfAssessmentSkeletonLoader from './SelfAssessmentSkeletonLoader';
import { getAllSelfAssessments } from '../../../helper/api.helper';
import InstituteDetails from '../home/institute-details/InstituteDetails';

const SelfAssessmentList = () => {
  const [allSelfAssessments, setAllSelfAssessments] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const orgCode = getOrgCode();
    getAllSelfAssessments(orgCode)
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'success') {
          setAllSelfAssessments(res.data?.selfAssessments);
        } else {
          toast.error(res.message);
          navigate('/');
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message);
      });
  }, []);
  return (
    <div className="self-assessment-wrapper">
      {isLoading ? (
        <div className="skeleton-div">
          <SelfAssessmentSkeletonLoader />
        </div>
      ) : (
        <div
          style={{
            padding: window.innerWidth > 600 ? 'var(--space-lg)' : 'var(--space-md)'
          }}>
          <div className="margin-bottom--lg">
            <InstituteDetails />
          </div>
          <div className="inner-div">
            {allSelfAssessments?.map((assessment, index) => (
              <Link
                key={index}
                to={`/assessments/${assessment.slug}`}
                style={{ textDecoration: 'none', color: 'inherit' }}>
                <AssessmentItem assessment={assessment} />
              </Link>
            ))}
          </div>
        </div>
      )}

      <style jsx>
        {`
          .self-assessment-wrapper {
            min-height: 90vh;
            display: flex;
            justify-content: center;
            max-width: 1150px;
            margin: auto;
          }
          .skeleton-div {
            flex-grow: 1;
            padding-bottom: 20px;
          }
          .inner-div {
            width: 70%;
            max-width: 900px;
            padding-bottom: 20px;
            margin: auto;
          }
          @media only screen and (max-width: 1050px) {
            .inner-div {
              width: 80%;
            }
          }

          @media only screen and (max-width: 950px) {
            .inner-div {
              width: 95%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default SelfAssessmentList;
